<template>
  <div>
    <v-tabs class="tab-headerblk" v-model="currentTab" height="60px" show-arrows background-color="#282828" color="#facc15">
      <!-- <v-tab href="#tab-non-otp-trip">Non-OTP Trips</v-tab>
      <v-tab href="#tab-otp-trip">OTP Trips</v-tab> -->
      <v-tab href="#tab-verified-list">Billing Trips</v-tab>
      <v-tab href="#tab-dispute-list">Non Billing Trips</v-tab>
      <v-tab href="#tab-rejected-list">Rejected Trips</v-tab>
      <v-tab href="#tab-invoice-llst" v-if="ownerId == 1">Invoice History</v-tab>
      <v-tab href="#tab-invoice-generate" v-if="ownerId == 1">Generate Invoice</v-tab>
      <!-- <v-tab href="#tab-rectified-list">Rectified List</v-tab> -->
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <!-- <v-tab-item id="tab-non-otp-trip" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition" v-if="currentTab === 'tab-non-otp-trip'">
        <VerifiedList :tab="currentTab" :verifiedStatus="0"></VerifiedList>
      </v-tab-item>
       <v-tab-item id="tab-otp-trip" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition" v-if="currentTab === 'tab-otp-trip'">
        <VerifiedList :tab="currentTab" :verifiedStatus="3"></VerifiedList>
      </v-tab-item> -->
      <v-tab-item id="tab-verified-list" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition" v-if="currentTab === 'tab-verified-list'">
        <VerifiedList :tab="currentTab" :verifiedStatus="10" :ownerId="ownerId"></VerifiedList>
      </v-tab-item>
      <v-tab-item id="tab-dispute-list" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition" v-if="currentTab === 'tab-dispute-list'">
        <DisputeList :tab="currentTab" :verifiedStatus="1" :ownerId="ownerId"></DisputeList>
      </v-tab-item>
      <v-tab-item id="tab-rejected-list" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition" v-if="currentTab === 'tab-rejected-list'">
        <VerifiedList :tab="currentTab" :verifiedStatus="4" :ownerId="ownerId"></VerifiedList>
      </v-tab-item>

      <v-tab-item id="tab-invoice-llst" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <Invoice></Invoice>
      </v-tab-item>

      <v-tab-item id="tab-invoice-generate" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <InvoiceGenerate></InvoiceGenerate>
      </v-tab-item>
      <!-- <v-tab-item id="tab-rectified-list" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition" v-if="currentTab === 'tab-rectified-list'">
    <VerifiedList :tab="currentTab" :verifiedStatus="2"></VerifiedList>
   </v-tab-item> -->
    </v-tabs-items>
  </div>
</template>
<script>
import VerifiedList from "./VerifiedList.vue";
import DisputeList from "./DisputeList.vue";
import Invoice from "../../invoice/Invoice.vue";
import InvoiceGenerate from "../../invoice/InvoiceGenerate.vue";
export default {
  name: "Verification",
  components: {
    VerifiedList,
    DisputeList,
    Invoice,
    InvoiceGenerate,
  },
  data() {
    return {
      currentTab: "tab-verified-list",
      ownerId: 0,
    };
  },
  mounted() {
    this.ownerId = localStorage.getItem("ownerId");
    const savedVerificationTab = localStorage.getItem("verificationTab");
    const validTabs = ["tab-non-otp-trip", "tab-otp-trip","tab-to-be-verified", "tab-verified-list", "tab-dispute-list", "tab-rejected-list","tab-invoice-llst","tab-invoice-generate"];
    if (savedVerificationTab && validTabs.includes(savedVerificationTab)) {
      this.currentTab = savedVerificationTab;
    }
  },
  watch: {
    currentTab(newTab) {
      localStorage.setItem("verificationTab", newTab);
    },
  },
  beforeDestroy() {
    localStorage.removeItem("verificationTab");
  },
};
</script>
<style scoped>
@import "../verification/verification.scss";
</style>
